"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Triangle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Triangle = function Triangle(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "react-spinner-loader-svg"
    },
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      id: "triangle",
      width: props.width,
      height: props.height,
      viewBox: "-3 -4 39 39",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("polygon", {
      fill: "transparent",
      stroke: props.color,
      strokeWidth: "1",
      points: "16,0 32,32 0,32"
    })))
  );
};

exports.Triangle = Triangle;
Triangle.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string
};
Triangle.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};